export const getAnswerLetterLabel = (index: number) => {
  const alphabetCode = 65
  return String.fromCharCode(index + alphabetCode)
}
